document.addEventListener('DOMContentLoaded', () => {
    // Hero Synchronized Dual Slider Logic
    const heroBgs = document.querySelectorAll('.hero-bg-slide');
    const heroCards = document.querySelectorAll('.hero-product-slide');
    const cardWrapper = document.getElementById('heroCardWrapper');
    const counter = document.getElementById('heroSlideCounter');
    
    if (heroCards.length > 0 && heroBgs.length > 0) {
        let currentHeroIndex = 0;
        const totalHeroSlides = heroCards.length;

        function goToHeroSlide(index) {
            if(heroBgs[currentHeroIndex]) heroBgs[currentHeroIndex].classList.remove('active');
            if(heroCards[currentHeroIndex]) heroCards[currentHeroIndex].classList.remove('active');

            currentHeroIndex = (index + totalHeroSlides) % totalHeroSlides;

            if(heroBgs[currentHeroIndex]) heroBgs[currentHeroIndex].classList.add('active');
            if(heroCards[currentHeroIndex]) heroCards[currentHeroIndex].classList.add('active');

            const newColor = heroCards[currentHeroIndex].getAttribute('data-color');
            if (newColor && cardWrapper) {
                cardWrapper.style.backgroundColor = newColor;
            }

            if (counter) {
                counter.textContent = `0${currentHeroIndex + 1} / 0${totalHeroSlides}`;
            }
        }

        const prevHeroBtn = document.getElementById('prevHeroBtn');
        const nextHeroBtn = document.getElementById('nextHeroBtn');

        if (nextHeroBtn) nextHeroBtn.addEventListener('click', () => goToHeroSlide(currentHeroIndex + 1));
        if (prevHeroBtn) prevHeroBtn.addEventListener('click', () => goToHeroSlide(currentHeroIndex - 1));

        // Auto-cycle hero every 3.5s
        let heroTimer = setInterval(() => {
            goToHeroSlide(currentHeroIndex + 1);
        }, 3500);

        // Reset timer on user interaction
        [prevHeroBtn, nextHeroBtn].forEach(btn => {
            if (btn) {
                btn.addEventListener('click', () => {
                    clearInterval(heroTimer);
                    heroTimer = setInterval(() => goToHeroSlide(currentHeroIndex + 1), 3500);
                });
            }
        });
    }
});
